<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>下级管理</h1>
        <p>直属下级渠道。{{ childLevel ? '可为下一级开设账号，提交后由总部审核。' : '当前级别只发展 C 端，不能再开下级。' }}</p>
      </div>
      <div class="ch-actions">
        <button v-if="childLevel" class="ch-btn gold" type="button" @click="open = true">为下级开设账号</button>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">直属下级</div><div class="v">{{ rows.length }} 家</div><div class="s">待审核 {{ pending }} 家</div></div>
      <div class="ch-metric"><div class="k">可开设级别</div><div class="v" style="font-size:18px">{{ childLevel ? levelName(childLevel) : '不能开下级' }}</div></div>
      <div class="ch-metric"><div class="k">正常经营</div><div class="v">{{ approved }} 家</div><div class="s">已通过审核</div></div>
    </div>
    <div class="ch-panel">
      <div class="ch-tabs">
        <button type="button" :class="{ on: !customer }" @click="customer = false">下级渠道</button>
        <button type="button" :class="{ on: customer }" @click="customer = true">企业客户</button>
      </div>
      <p v-if="$route.query.keyword" class="ch-note" style="margin-bottom:12px">当前筛选：{{ $route.query.keyword }}</p>
      <table v-if="!customer" class="ch-table">
        <thead><tr><th>下级渠道</th><th>级别</th><th>授权区域</th><th>手机</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in shown" :key="row.id">
            <td>{{ row.name }}</td>
            <td>{{ levelName(row.levelCode) }}</td>
            <td>{{ row.regionName || '—' }}</td>
            <td>{{ row.phone || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 'APPROVED' ? 'ok' : 'warn'">{{ statusName(row.status) }}</span></td>
          </tr>
          <tr v-if="!shown.length"><td colspan="5" class="ch-empty">没有匹配的下级</td></tr>
        </tbody>
      </table>
      <div v-else class="ch-empty">企业客户名单来自邀请码绑定的 C 端用户，后台还没有这份名单。客户报备请到「客户报备」。</div>
    </div>
    <el-dialog title="为下级开设账号" :visible.sync="open" width="480px">
      <el-form label-width="90px" size="small">
        <el-form-item label="级别">{{ levelName(childLevel) }}</el-form-item>
        <el-form-item label="主体"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="手机"><el-input v-model="form.phone" /></el-form-item>
        <el-form-item label="区划代码"><el-input v-model="form.regionCode" /></el-form-item>
        <el-form-item label="地区名"><el-input v-model="form.regionName" /></el-form-item>
      </el-form>
      <p class="ch-note">开设渠道商账号由总部核验后激活。本主体内部员工请到「子账号管理」，那里不需要企业信息。代金券不能由上级划给下级。</p>
      <div slot="footer">
        <el-button size="small" @click="open = false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">提交总部审核</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChannelOverview, getChannelPartners, saveChannelPartner } from '@/api/admin'
import { CHILD_LEVEL, levelName, statusName } from './labels'

export default {
  name: 'PartnerDownline',
  data() {
    return { selfId: null, childLevel: '', rows: [], open: false, customer: false, form: { name: '', phone: '', regionCode: '', regionName: '' } }
  },
  computed: {
    pending() { return this.rows.filter(item => item.status === 'PENDING').length },
    approved() { return this.rows.filter(item => item.status === 'APPROVED').length },
    shown() {
      const keyword = ((this.$route.query && this.$route.query.keyword) || '').trim()
      if (!keyword) return this.rows
      return this.rows.filter(item => [item.name, item.regionName, item.phone].join(' ').indexOf(keyword) >= 0)
    }
  },
  created() { this.load() },
  methods: {
    levelName, statusName,
    async load() {
      const overview = await getChannelOverview()
      const partner = overview.partner || {}
      this.selfId = overview.partnerId
      this.childLevel = CHILD_LEVEL[partner.levelCode] || ''
      const partners = await getChannelPartners()
      this.rows = (partners.list || []).filter(item => item.id !== this.selfId)
    },
    async submit() {
      await saveChannelPartner({ ...this.form, levelCode: this.childLevel, parentId: this.selfId })
      this.open = false
      this.$message.success('已提交，等待总部审核')
      this.load()
    }
  }
}
</script>
